/**
 * @generated SignedSource<<f61a49b0690bdcaf5f65ffcdd6e587d7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespAboutItemPanel_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespDetails_user" | "PdpRespPricingGuidance_user" | "PdpSharedDescriptionAdditionalOptions_user">;
  readonly " $fragmentType": "PdpRespAboutItemPanel_user";
};
export type PdpRespAboutItemPanel_user$key = {
  readonly " $data"?: PdpRespAboutItemPanel_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespAboutItemPanel_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isClient"
    },
    {
      "kind": "RootArgument",
      "name": "isRespTabsRedesignVariant"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespAboutItemPanel_user",
  "selections": [
    {
      "condition": "isRespTabsRedesignVariant",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedDescriptionAdditionalOptions_user"
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespDetails_user"
    },
    {
      "condition": "isClient",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespPricingGuidance_user"
        }
      ]
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "b44e23cd8df611edd2f9bb7320220c64";

export default node;
